import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";

export const requestNotificationToken = async (): Promise<string | null> => {

  try {
    const token = await getToken(messaging, {
      vapidKey:
        "BO_6bpvFz6_cyut1dSOL4cRWuaCkMomUpeFtIup_PSOYHyc2oqnv53u-u6wHyYylAGEFzBAclij5DGTgWRO3KQA",
    });

    if (token) {
      localStorage.setItem("fcm_token", token);

      return token;
    } else {
      console.error("No registration token available. Request permission to generate one.");
      return null;
    }
  } catch (error) {
    console.error("An error occurred while retrieving token.", error);
    throw error;
  }
};
